<template>
  <category-markup
    class="body-bg-color membership-template-builder"
    :style="[customCss]"
  >
    <template slot="header" v-if="isPreview">
      <category-header :getThemeSettings="getThemeSettings">
        <template slot="logo">
          <header-logo
            v-if="isPreview"
            :logoPath="membershipMasterData.logo"
            :logoSize="membershipMasterData.logo_size"
            :altText="'Header Logo'"
          ></header-logo>
        </template>
        <template slot="menus">
          <menu-items
            :isPreview="isPreview"
            :position="'header'"
            :activeMenus="activeHeaderMenu"
            :sendToPath="sendToPath"
          ></menu-items>
        </template>
        <template slot="profile" v-if="user">
          <header-profile
            :user="user"
            :openProfilePopup="openProfilePopup"
            :logoutUser="logoutUser"
            :isPortal="isPortal"
            :backPortalPage="backPortalPage"
            :profileLabel="membershipMasterData.gen_settings && JSON.parse(membershipMasterData.gen_settings).profile_label"
            :logoutLabel="membershipMasterData.gen_settings &&  JSON.parse(membershipMasterData.gen_settings).logout_label"
          ></header-profile>
        </template>
        <template slot="button" v-else>
          <category-button
            :buttonText="'Log In'"
            :buttonCallback="() => {}"
            :callbackParam="1"
            :specialHover="1"
            :getThemeSettings="getThemeSettings"
          ></category-button>
        </template>
      </category-header>
    </template>
    <template slot="hero">
      <category-banner
        :overlayColor="activeElement.value.configuration_options.overlay_color"
        :showBanner="activeElement.value.show_banner"
        :bannerType="activeElement.value.banner_type"
      >
        <template slot="avatar">
          <banner-avatar
            :isPreview="isPreview"
            :featuredImage="activeElement.value.featured_image"
            :featuredVideoEmbed="activeElement.value.featured_video"
            :overlayColor="
              activeElement.value.configuration_options.overlay_color
            "
            :updateFeaturedImage="updateBannerFeaturedImage"
            :updateFeaturedVideo="updateBannerFeaturedVideo"
            :updateOverlay="updateBannerOverlayColor"
            :updateType="updateBannerType"
            :bannerSettings="activeElement.value.configuration_options"
          ></banner-avatar>
        </template>
        <template slot="story">
          <banner-story>
            <template slot="title">
              <banner-title
                :text="activeElement.value.name_markup"
                :updateTitle="updateBannerTitle"
                :isPreview="isPreview"
              ></banner-title>
            </template>
            <template slot="description">
              <banner-description
                :text="activeElement.value.description_markup"
                :updateDescription="updateBannerDescription"
                :isPreview="isPreview"
              ></banner-description>
            </template>
          </banner-story>
        </template>
      </category-banner>
    </template>
    <template slot="breadcrumb">
      <!-- <filters class="membership-layout-container"></filters> -->
      <breadcrumb
        :isPreview="isPreview"
        :hierarchy="hierarchy"
        :activeElement="activeElement"
        :activateElement="activateElement"
        :sendToPath="sendToPath"
        :getThemeSettings="getThemeSettings"
        :courseSettings="courseSettings"
        :getHomeMenuData="getHomeMenuData"
      ></breadcrumb>
    </template>
    <template slot="courses">
      <div v-if="listElements.length > 0">
        <category-courses
          class="membership-layout-container"
          :tileView="tileView"
          :getThemeSettings="getThemeSettings"
        >
          <template slot="title">
            <div class="body-heading-color">
              {{ activeElement.value.name }}
            </div>
          </template>
          <template slot="tile-view-icons">
            <tile-view-icons
              v-if="!isPreview"
              :tileView="tileView"
              :changeTileView="
                ($event) => {
                  tileView = $event;
                }
              "
            ></tile-view-icons>
          </template>
          <template slot="courses-list">
            <courses-tile
              v-for="(subcategory, index) in listElements"
              :key="index"
              :cover="subcategory.featured_image"
              :tileView="tileView"
              :title="subcategory.name"
              :hoverTitle="subcategory.name"
              :getThemeSettings="getThemeSettings"
              :description="subcategory.description"
              :class="'half-tile-hover'"
            >
              <template slot="button">
                <category-button
                  :class="[tileView === 'grid' ? 'w-full' : 'w-auto']"
                  :buttonText="
                    $t('frontend_groovemember_course_edit_access_now')
                  "
                  :buttonCallback="!isPreview ? activateElement : sendToPath"
                  :callbackParam="
                    !isPreview
                      ? { e: '', el: subcategory }
                      : { name: 'post', params: { id: subcategory.slug } }
                  "
                  :specialHover="0"
                  :getThemeSettings="getThemeSettings"
                ></category-button>
              </template>
            </courses-tile>
          </template>
        </category-courses>
      </div>
      <div v-if="listElements.length < 1 && !isPreview">
        <empty-cat
          :allowed="['subcategory', 'post']"
          :triggerAddNewHirearchyItem="triggerAddNewHirearchyItem"
        ></empty-cat>
      </div>
    </template>
    <template slot="footer" v-if="isPreview">
      <category-footer :getThemeSettings="getThemeSettings">
        <template slot="logo">
          <footer-logo
            v-if="isPreview"
            :logoPath="membershipMasterData.footer_logo"
            :altText="'Footer Logo'"
            :logoSize="membershipMasterData.footer_logo_size"
          ></footer-logo>
        </template>
        <template slot="menus">
          <menu-items
            :isPreview="isPreview"
            :position="'footer'"
            :activeMenus="activeFooterMenu"
            :sendToPath="sendToPath"
          ></menu-items>
        </template>
      </category-footer>
    </template>
  </category-markup>
</template>
<script>
import CategoryMarkup from './category-markup';

import CategoryHeader from '../../../common/header/header';
import HeaderLogo from '../../../common/header/logo';
import HeaderProfile from '../../../common/header/profile';

import CategoryBanner from '../../../common/banner/banner';
import BannerAvatar from '../../../common/banner/avatar/avatar';
import BannerStory from '../../../common/banner/story/story';
import BannerTitle from '../../../common/banner/story/title';
import BannerDescription from '../../../common/banner/story/description';

import TileViewIcons from '../../../common/courses/tile-view-icons';
import CategoryCourses from '../../../common/courses/courses';
import CoursesTile from '../../../common/courses/tile';

import CategoryFooter from '../../../common/footer/footer';
import FooterLogo from '../../../common/footer/logo';

import Filters from '../../../common/filters';
import CategoryButton from '../../../common/button';
import MenuItems from '../../../common/menuItems';
import Breadcrumb from '../../../common/breadcrumb';
import EmptyCat from '../../../common/emptyCat';

export default {
  name: 'CategoryTemplate',
  mixins: [],
  components: {
    CategoryMarkup,
    CategoryHeader,
    HeaderLogo,
    HeaderProfile,
    CategoryBanner,
    BannerAvatar,
    BannerStory,
    BannerTitle,
    BannerDescription,
    TileViewIcons,
    CategoryCourses,
    CoursesTile,
    CategoryFooter,
    FooterLogo,
    Filters,
    CategoryButton,
    MenuItems,
    Breadcrumb,
    EmptyCat,
  },
  data() {
    return {};
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: null,
    },
    openProfilePopup: {
      type: Function,
      default: () => {},
    },
    logoutUser: {
      type: Function,
      default: () => {},
    },
    triggerAddNewHirearchyItem: {
      type: Function,
      default: () => {},
    },
    hierarchy: {},
    activeElement: {},
    activateElement: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    activeHeaderMenu: {
      type: Array,
      default: () => [],
    },
    activeFooterMenu: {
      type: Array,
      default: () => [],
    },
    updateBannerTitle: {
      type: Function,
      default: () => {},
    },
    updateBannerDescription: {
      type: Function,
      default: () => {},
    },
    updateBannerFeaturedImage: {
      type: Function,
      default: () => {},
    },
    updateBannerFeaturedVideo: {
      type: Function,
      default: () => {},
    },
    updateBannerOverlayColor: {
      type: Function,
      default: () => {},
    },
    updateBannerType: {
      type: Function,
      default: () => {},
    },
    updatetileView: {
      type: Function,
      default: () => {},
    },
    getThemeSettings: {},
    membershipMasterData: {},
    totalLessons: {
      required: true,
    },
    completedLessons: {
      required: true,
    },
    isPortal: {
      type: Boolean,
      deafult: false,
    },
    backPortalPage: {
      type: Function,
      default: () => {},
    },
    courseSettings:{}
  },
  computed: {
    getHomeMenuData() {
        return this.activeHeaderMenu.find(item => item.is_default==1);
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-body-bg-color': this.themeSettings.body_section.bg_color,
        '--template-body-heading-color': this.themeSettings.body_section
          .body_heading_color,
      };
    },
    listElements() {
      return this.activeElement.value.children.filter(
        (el) =>
          el.is_default === 0 &&
          ['subcategory', 'post'].includes(el.type) &&
          !el.is_hidden
      );
    },
    directPostsList() {
      return this.activeElement.value.children.filter(
        (el) => el.is_default === 0 && el.type === 'post' && !el.is_hidden
      );
    },
    tileView: {
      get() {
        if (
          this.activeElement.value.configuration_options.hasOwnProperty(
            'tile_view'
          )
        ) {
          return this.activeElement.value.configuration_options.tile_view;
        }

        return 'grid';
      },
      set(value) {
        this.updatetileView(value);
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.body-bg-color {
  background-color: var(--template-body-bg-color);
}
.body-heading-color {
  color: var(--template-body-heading-color);
}
</style>

<style lang="scss">
/* .membership-layout-container{
      max-width: 75%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
} */
.membership-layout-container {
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.btn-radius {
  border-radius: 6px !important;
}
.half-tile-hover {
  .tile-wrapper {
    .static {
      position: relative;
    }
  }
}
</style>